// extracted by mini-css-extract-plugin
module.exports = {"investWrap":"Invest_investWrap__Ydgx_","content":"Invest_content__QZhYc","contentWrap":"Invest_contentWrap__onC0O"};